module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": "brown lighten-2",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Relevés de suivi alimentaire")])], 1), _vm._v(" "), _c('v-card', [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "yellow",
      "top": "",
      "right": "",
      "absolute": ""
    },
    on: {
      "click": _vm.addFractionningDialog
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _vm._l((_vm.fractionnings), function(fractionning, index) {
    return [_c('v-subheader', {
      key: fractionning.id
    }, [_vm._v("\n                  " + _vm._s(_vm.fractionningDescription(fractionning)) + "\n                  "), _c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.editFractionningDialog(fractionning.date)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.surveyMeals[fractionning.date]), function(meal, index) {
      return [_c('v-list-tile', {
        key: fractionning.id + ',' + meal.id,
        class: {
          'red': meal.id === _vm.selectedMealId, 'lighten-4': meal.id === _vm.selectedMealId
        },
        attrs: {
          "avatar": "",
          "ripple": ""
        },
        on: {
          "click": function($event) {
            _vm.selectMeal(meal.id)
          }
        }
      }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("restaurant")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.mealIndexName(meal)))])], 1)], 1)]
    })]
  })], 2), _vm._v(" "), (_vm.fractionnings.length === 0) ? _c('v-card-text', {
    staticClass: "Aligner",
    staticStyle: {
      "height": "80px"
    }
  }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12 sm5"
  }, [_c('router-view', {
    attrs: {
      "name": "mealElements"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12 sm3"
  }, [_c('router-view', {
    attrs: {
      "name": "favorites"
    },
    on: {
      "addFavorite": _vm.addFavorite
    }
  })], 1), _vm._v(" "), (_vm.fractionningDialog) ? _c('fractionning-dialog', {
    attrs: {
      "title": "Journée de relevé alimentaire",
      "disableDate": _vm.disableFractionningDate,
      "value": _vm.editedFractionning
    },
    on: {
      "input": _vm.setFractionning,
      "close": function($event) {
        _vm.fractionningDialog = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70da6b38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/meals/UserMealSurveys.vue
// module id = 1202
// module chunks = 1